import Chip from '@mui/material/Chip';
import { ChipProps } from '@mui/material';
import { Icon } from '../Icon';

export type TagProps = Pick<ChipProps, 'label' | 'onDelete' | 'sx' | 'className'>;

export const Tag = (props: TagProps) => {
  return <Chip {...props} deleteIcon={<Icon name="close" width={12} height={12} />} />;
};
